import axios from "axios";

export const deleteMenuById = async (id) => {
  try {
    const response = await axios.delete(`http://localhost:8080/webnet-hms/api/menus/delete/${id}`);
    window.alert("Menu deleted successfully!");
    return response.data;
  } catch (error) {
    console.error("Error deleting menu:", error);
    window.alert("Failed to delete menu.");
  }
};
